import { render, staticRenderFns } from "./VinAppendsChip.vue?vue&type=template&id=67946459&"
import script from "./VinAppendsChip.vue?vue&type=script&lang=js&"
export * from "./VinAppendsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports